import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getInvListRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
  pageNum: number; // 页码，从1开始 ,
  pageSize: number; //每页记录数，1-100
}

export interface InvResultDataVO {
  projectName?: string; //活动名称 ,
  starPhone?: string; // 被邀手机号 ,
  status?: string; // 邀请状态
}

interface getInvListResponse extends BaseResponse {
  Data: InvResultDataVO[];
}

/**
 * 获取邀请记录
 * @param params
 * @returns
 */
export async function getInvList(request: getInvListRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvList');
  return DsbcApi.fetch<getInvListResponse>(url, request, true, options);
}
